import React from "react";

const ArrowRightIcon = () => (
  <svg
    className="w-4 h-4 ml-2"
    fill="none"
    stroke="currentColor"
    viewBox="0 0 24 24"
  >
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2"
      d="M17 8l4 4m0 0l-4 4m4-4H3"
    ></path>
  </svg>
);

// --- Sub-Components ---
const CultureSection = () => (
  <section id="culture" className="lg:py-24 md:py-10 sm:py-10 bg-slate-50">
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
      <div className="flex flex-col lg:flex-row items-center gap-16">
        <div className="lg:w-1/2 relative">
          <div className="relative rounded-2xl overflow-hidden shadow-2xl">
            <img
              src="https://picsum.photos/seed/office/800/600"
              alt="Team collaborating in office"
              className="w-full h-auto object-cover transform hover:scale-105 transition-transform duration-700"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-black/50 to-transparent"></div>
          </div>
          <div className="absolute -bottom-6 -right-6 w-48 h-48 bg-blue-200 rounded-full -z-10 blur-2xl opacity-60 pointer-events-none"></div>
        </div>

        <div className="px-5 pb-5 lg:w-1/2">
          <h2 className="text-3xl md:text-4xl font-bold text-slate-900 mb-6">
            Driven by Purpose, United by Passion
          </h2>
          <p className="text-gray-600 text-lg mb-6 leading-relaxed">
            We believe that the best work happens when people feel supported,
            challenged, and free to be themselves. Our culture is built on
            transparency, continuous learning, and a relentless pursuit of
            excellence.
          </p>
          <ul className="space-y-4 mb-8">
            {[
              "Autonomy & Ownership over micromanagement.",
              "Diverse perspectives that drive innovation.",
              "Commitment to work-life balance and mental health.",
            ].map((item, i) => (
              <li key={i} className="flex items-start">
                <div className="flex-shrink-0 mt-1">
                  <svg
                    className="w-6 h-6 text-blue-600"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth="2"
                      d="M5 13l4 4L19 7"
                    ></path>
                  </svg>
                </div>
                <span className="ml-3 text-gray-700 font-medium">{item}</span>
              </li>
            ))}
          </ul>
          <a
            href="#"
            className="inline-flex items-center text-blue-600 font-bold hover:text-blue-800 transition group"
          >
            Read about our journey <ArrowRightIcon />
          </a>
        </div>
      </div>
    </div>
  </section>
);

export default CultureSection;
